import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import centralApiAxios from "../../axios/centralApiAxios";
import { CREATE_SIGNUP } from "../actions";
import { createSignupError } from "./actions";
import { getActivityHeadersUpdated } from "../../utils/parentChildActivities";

const CREATE_SIGNUP_ERROR = "Signup process failed.";

export function* watchCreateSignup() {
  yield takeEvery(CREATE_SIGNUP, createSignup);
}

const createSignupAsync = async (signup, payload) => {
  try {
    const responseObject = await centralApiAxios.post("tenants", signup, getActivityHeadersUpdated(payload));
    if (responseObject.data) {
      if (responseObject.data.otac) {
        return {
          otac: responseObject.data.otac,
          contactid: responseObject.data.contactId,
          tenantSiteLink: responseObject.data.tenantSiteLink,
        };
      }
      return {
        otac: responseObject.data.otac,
        contactid: responseObject.data.contactId,
        tenantSiteLink: responseObject.data.tenantSiteLink,
        errorMessage: responseObject.data.errorMessage,
      };
    }
    return {
      message: CREATE_SIGNUP_ERROR,
    };
  } catch (err) {
    return {
      message: CREATE_SIGNUP_ERROR,
    };
  }
};

function* createSignup({ payload }) {
  const { history } = payload;

    if (payload.isSagaExecuted)
    {
         yield put(createSignupError("saga called"));
    }
    else{
        if (!payload.isSagaExecuted)
        {
            payload.isSagaExecuted = true;
        }

  try {
    const resultReturned = yield call(createSignupAsync, payload.signup, payload);
    if (!resultReturned.message) {
      if (resultReturned.errorMessage) {
        yield put(
          createSignupError(
            CREATE_SIGNUP_ERROR +
            (resultReturned.errorMessage ? resultReturned.errorMessage : "")
          )
        );
      } else {
        if (payload.isRightPanel) {
          window.location.reload();
        } else {
          if (resultReturned.tenantSiteLink) {
            window.location.href = `${resultReturned.tenantSiteLink}/user/auto-login?firstname=${payload.signup.first_name}&lastname=${payload.signup.last_name}&email=${payload.signup.email_address}&cid=${resultReturned.contactid}&otac=${resultReturned.otac}`;
          } else {
            history.push("/app/home");
          }
        }
      }
    } else {
      yield put(createSignupError(resultReturned.message));
    }
  } catch (errorExp) {
    yield put(createSignupError(CREATE_SIGNUP_ERROR));
  }        
      }
}

export default function* rootSaga() {
  yield all([fork(watchCreateSignup)]);
}
